import React from 'react';
import { BonusHero } from '../components/bonuses/BonusHero';
import { BonusProblem } from '../components/bonuses/BonusProblem';
import { BonusLogic } from '../components/bonuses/BonusLogic';
import { BonusOne } from '../components/bonuses/BonusOne';
import { BonusTwo } from '../components/bonuses/BonusTwo';
import { BonusThree } from '../components/bonuses/BonusThree';
import { BonusCTA } from '../components/bonuses/BonusCTA';
import { Footer } from '../components/Footer';
export function BonusPage() {
  return <div className="w-full min-h-screen" style={{
    backgroundColor: 'var(--cream)'
  }} data-id="element-730">
      <BonusHero data-id="element-731" />
      <BonusCTA variant="mini" data-id="element-732" />
      <BonusProblem data-id="element-733" />
      <BonusLogic data-id="element-734" />
      <BonusOne data-id="element-735" />
      <BonusCTA variant="mini" data-id="element-736" />
      <BonusTwo data-id="element-737" />
      <BonusCTA variant="mini" data-id="element-738" />
      <BonusThree data-id="element-739" />
      <BonusCTA variant="full" data-id="element-740" />
      <Footer data-id="element-741" />
    </div>;
}